import { useMutation } from '@apollo/client';
import { Button, createStyles, makeStyles, Theme } from '@material-ui/core';
import { CloudUpload } from '@material-ui/icons';
import React, { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { captureSilentError } from '../helpers/ErrorHelper';
import { UploadLogsFromTerminalDocument } from '../services/graphql/typed-operations';
import { addSnackbarMessages, snackbarMessagesState } from '../store/app';
import { isAdminSelector } from '../store/auth';
import { gastronomyState } from '../store/gastronomy';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      width: '100%'
    },
    rightIcon: {
      marginLeft: theme.spacing(1)
    }
  })
);

const UploadLogsFromTerminalButton: React.FC = () => {
  const classes = useStyles();
  const gastronomy = useRecoilValue(gastronomyState);
  const setSnackbarMessages = useSetRecoilState(snackbarMessagesState);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const isAdmin = useRecoilValue(isAdminSelector);

  const [uploadLogsFromTerminalMutation] = useMutation(
    UploadLogsFromTerminalDocument
  );

  const uploadLogsAction = async (): Promise<void> => {
    if (gastronomy) {
      setIsButtonDisabled(true);
      try {
        const { data } = await uploadLogsFromTerminalMutation({
          variables: { user_uuid: gastronomy.uuid }
        });

        if (!data) {
          return;
        }

        if (data.uploadLogsFromTerminal?.status) {
          addSnackbarMessages(
            [
              {
                type: 'success',
                message: 'POS Sync ausgeführt!'
              }
            ],
            setSnackbarMessages
          );
        }
      } catch (error) {
        captureSilentError(error);
      }
    }
  };

  if (isAdmin) {
    return (
      <Button
        variant="contained"
        color="default"
        className={classes.button}
        onClick={uploadLogsAction}
        disabled={isButtonDisabled}
      >
        Upload Logs from Terminal
        <CloudUpload className={classes.rightIcon} />
      </Button>
    );
  }
  return null;
};

export default UploadLogsFromTerminalButton;
